const manageRangeFiltersData = (previousActiveFiltersList, rangeWithFilterName = false) => {
  let minKey = 'min';
  let maxKey = 'max';
  const activeFiltersList = previousActiveFiltersList;
  const rangeFiltersList = {};
  if ('priceMin' in activeFiltersList && 'priceMax' in activeFiltersList) {
    if (rangeWithFilterName) {
      minKey = 'priceMin';
      maxKey = 'priceMax';
    }
    rangeFiltersList.price = {
      [minKey]: activeFiltersList.priceMin,
      [maxKey]: activeFiltersList.priceMax,
    };
    delete activeFiltersList.priceMin;
    delete activeFiltersList.priceMax;
  } else if (
    'priceMin' in activeFiltersList
    && !('priceMax' in activeFiltersList)
  ) {
    if (rangeWithFilterName) {
      minKey = 'priceMin';
    }
    rangeFiltersList.price = { [minKey]: activeFiltersList.priceMin };
    delete activeFiltersList.priceMin;
  } else if (
    !('priceMin' in activeFiltersList)
    && 'priceMax' in activeFiltersList
  ) {
    if (rangeWithFilterName) {
      maxKey = 'priceMax';
    }
    rangeFiltersList.price = { [maxKey]: activeFiltersList.priceMax };
    delete activeFiltersList.priceMax;
  }
  if ('mqpriceMin' in activeFiltersList && 'mqpriceMax' in activeFiltersList) {
    if (rangeWithFilterName) {
      minKey = 'mqpriceMin';
      maxKey = 'mqpriceMax';
    }
    rangeFiltersList.mqprice = {
      [minKey]: activeFiltersList.mqpriceMin,
      [maxKey]: activeFiltersList.mqpriceMax,
    };
    delete activeFiltersList.mqpriceMin;
    delete activeFiltersList.mqpriceMax;
  } else if (
    'mqpriceMin' in activeFiltersList
    && !('mqpriceMax' in activeFiltersList)
  ) {
    if (rangeWithFilterName) {
      minKey = 'mqpriceMin';
    }
    rangeFiltersList.mqprice = {
      [minKey]: activeFiltersList.mqpriceMin,
    };
    rangeFiltersList.mqprice = { min: activeFiltersList.mqpriceMin };
    delete activeFiltersList.mqpriceMin;
  } else if (
    !('mqpriceMin' in activeFiltersList)
    && 'mqpriceMax' in activeFiltersList
  ) {
    if (rangeWithFilterName) {
      maxKey = 'mqpriceMax';
    }
    rangeFiltersList.mqprice = { [maxKey]: activeFiltersList.mqpriceMax };
    delete activeFiltersList.mqpriceMax;
  }
  if ('paymentMin' in activeFiltersList && 'paymentMax' in activeFiltersList) {
    if (rangeWithFilterName) {
      minKey = 'paymentMin';
      maxKey = 'paymentMax';
    }
    rangeFiltersList.payment = {
      [minKey]: activeFiltersList.paymentMin,
      [maxKey]: activeFiltersList.paymentMax,
    };
    delete activeFiltersList.paymentMin;
    delete activeFiltersList.paymentMax;
  } else if (
    'paymentMin' in activeFiltersList
    && !('paymentMax' in activeFiltersList)
  ) {
    if (rangeWithFilterName) {
      minKey = 'paymentMin';
    }
    rangeFiltersList.payment = { [minKey]: activeFiltersList.paymentMin };
    delete activeFiltersList.paymentMin;
  } else if (
    !('paymentMin' in activeFiltersList)
    && 'paymentMax' in activeFiltersList
  ) {
    if (rangeWithFilterName) {
      maxKey = 'paymentMax';
    }
    rangeFiltersList.payment = { [maxKey]: activeFiltersList.paymentMax };
    delete activeFiltersList.paymentMax;
  }
  if ('mqMin' in activeFiltersList && 'mqMax' in activeFiltersList) {
    if (rangeWithFilterName) {
      minKey = 'mqMin';
      maxKey = 'mqMax';
    }
    rangeFiltersList.mq = {
      [minKey]: activeFiltersList.mqMin,
      [maxKey]: activeFiltersList.mqMax,
    };
    delete activeFiltersList.mqMin;
    delete activeFiltersList.mqMax;
  } else if ('mqMin' in activeFiltersList && !('mqMax' in activeFiltersList)) {
    if (rangeWithFilterName) {
      minKey = 'mqMin';
    }
    rangeFiltersList.mq = { [minKey]: activeFiltersList.mqMin };
    delete activeFiltersList.mqMin;
  } else if (!('mqMin' in activeFiltersList) && 'mqMax' in activeFiltersList) {
    if (rangeWithFilterName) {
      maxKey = 'mqMax';
    }
    rangeFiltersList.mq = { [maxKey]: activeFiltersList.mqMax };
    delete activeFiltersList.mqMax;
  }
  if (
    'buildingYearMin' in activeFiltersList
    && 'buildingYearMax' in activeFiltersList
  ) {
    if (rangeWithFilterName) {
      minKey = 'buildingYearMin';
      maxKey = 'buildingYearMax';
    }
    rangeFiltersList.buildingYear = {
      [minKey]: activeFiltersList.buildingYearMin,
      [maxKey]: activeFiltersList.buildingYearMax,
    };
    delete activeFiltersList.buildingYearMin;
    delete activeFiltersList.buildingYearMax;
  } else if (
    'buildingYearMin' in activeFiltersList
    && !('buildingYearMax' in activeFiltersList)
  ) {
    if (rangeWithFilterName) {
      minKey = 'buildingYearMin';
    }
    rangeFiltersList.buildingYear = { [minKey]: activeFiltersList.buildingYearMin };
    delete activeFiltersList.buildingYearMin;
  } else if (
    !('buildingYearMin' in activeFiltersList)
    && 'buildingYearMax' in activeFiltersList
  ) {
    if (rangeWithFilterName) {
      maxKey = 'buildingYearMax';
    }
    rangeFiltersList.buildingYear = { [maxKey]: activeFiltersList.buildingYearMax };
    delete activeFiltersList.buildingYearMax;
  }
  return { ...activeFiltersList, ...rangeFiltersList };
};

export default manageRangeFiltersData;
